import { connect } from 'react-redux'
import { login } from '../../actions/auth'
import HeaderBar from './HeaderBar'

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        login: (data) => {
            dispatch(login(data))
        },
    }
}

const HeaderBarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(HeaderBar)

export default HeaderBarContainer
